import { RegisterUserLocation } from "../interfaces/register-user.response";

export const LOCATION_FALLBACK_PUERTA_DEL_SOL: RegisterUserLocation = {
  lat: 40.4169473,
  lng: -3.7035285,
  address: 'Puerta del Sol'
} as const;

export const SLIDE_VALIDATION_FIELDS: Record<number, string[]> = {
  0: ['startDate', 'endDate'],
  1: ['startLocationAddress'],
  2: ['tripType'],
  3: ['interestIdList'],
  4: ['transportMeans', 'maxDistanceWalking']
} as const;